package com.dotdrives.repository

import com.dotdrives.client.PipelineHealthClient
import com.dotdrives.model.DriveHealthEntry

interface PipelineHealthRepository {
    suspend fun list(orgId: String): Result<List<DriveHealthEntry>>
}

class SupabasePipelineHealthRepository(
    private val client: PipelineHealthClient = PipelineHealthClient(),
) : PipelineHealthRepository {
    override suspend fun list(orgId: String): Result<List<DriveHealthEntry>> =
        runCatching { client.list(orgId) }
}
